/* SET STATE */
export const SET_STATE_LABREQUESTREPORTROI = "SET_STATE_LABREQUESTREPORTROI"

/* LABREQUESTREPORTROIS */
export const GET_LABREQUESTREPORTROIS = "GET_LABREQUESTREPORTROIS"
export const GET_LABREQUESTREPORTROIS_SUCCESS = "GET_LABREQUESTREPORTROIS_SUCCESS"
export const GET_LABREQUESTREPORTROIS_FAIL = "GET_LABREQUESTREPORTROIS_FAIL"

/* LABREQUESTREPORTROI */
export const GET_LABREQUESTREPORTROI = "GET_LABREQUESTREPORTROI"
export const GET_LABREQUESTREPORTROI_SUCCESS = "GET_LABREQUESTREPORTROI_SUCCESS"
export const GET_LABREQUESTREPORTROI_FAIL = "GET_LABREQUESTREPORTROI_FAIL"

/**
 * ADD LABREQUESTREPORTROI
 */
 export const ADD_NEW_LABREQUESTREPORTROI = "ADD_NEW_LABREQUESTREPORTROI"
 export const ADD_LABREQUESTREPORTROI_SUCCESS = "ADD_LABREQUESTREPORTROI_SUCCESS"
 export const ADD_LABREQUESTREPORTROI_FAIL = "ADD_LABREQUESTREPORTROI_FAIL"

 /**
 * UPDATE LABREQUESTREPORTROI
 */
export const UPDATE_LABREQUESTREPORTROI = "UPDATE_LABREQUESTREPORTROI"
export const UPDATE_LABREQUESTREPORTROI_SUCCESS = "UPDATE_LABREQUESTREPORTROI_SUCCESS"
export const UPDATE_LABREQUESTREPORTROI_FAIL = "UPDATE_LABREQUESTREPORTROI_FAIL"

/**
 * DELETE LABREQUESTREPORTROI
 */
export const DELETE_LABREQUESTREPORTROI = "DELETE_LABREQUESTREPORTROI"
export const DELETE_LABREQUESTREPORTROI_SUCCESS = "DELETE_LABREQUESTREPORTROI_SUCCESS"
export const DELETE_LABREQUESTREPORTROI_FAIL = "DELETE_LABREQUESTREPORTROI_FAIL"
